import { ReactNode } from 'react'

interface GradientTextProps {
  children: ReactNode
  className?: string
  size?: string
}

export const GradientText = ({
  children,
  className = '',
  size = 'text-2xl',
}: GradientTextProps) => (
  <h3
    className={`${size} font-radio-grotesk bg-clip-text font-bold text-transparent ${className}`}
    style={{
      backgroundImage:
        'linear-gradient(115.12deg, rgb(253,149,67) 24.11%, rgb(249,150,205) 86.69%)',
    }}
  >
    {children}
  </h3>
)
